import * as React from "react";
const Twitter = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M13.712 10.622L20.413 3h-1.588l-5.818 6.618L8.36 3H3l7.027 10.007L3 21h1.588l6.144-6.989L15.64 21H21l-7.288-10.378zm-2.175 2.474l-.712-.997L5.16 4.17H7.6l4.571 6.4.712.996 5.943 8.319h-2.439l-4.85-6.788z" />
  </symbol>;
export default Twitter;